import RegionsModal from './RegionsModal';

export default RegionsModal;
